import { APIAttachment } from './apiTypes';

const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/tiff',
  'image/webp',
  'image/bmp',
];

const SVG_MIME_TYPES = ['image/svg+xml'];

const supportedMimeTypes = [...IMAGE_MIME_TYPES, ...SVG_MIME_TYPES] as const;

export const isSupportedMimeType = (mimeType: string): boolean =>
  new Set<string>(supportedMimeTypes).has(mimeType);

export const isSupportedSvgMimeType = (mimeType: string): boolean =>
  new Set<string>(SVG_MIME_TYPES).has(mimeType);

export const isSupportedImageMimeType = (mimeType: string): boolean =>
  new Set<string>(IMAGE_MIME_TYPES).has(mimeType);

export const extractMimeType = (contentType: string) => {
  const mimeTypeMatch = contentType.match(/^\s*([^;]+)\s*(?:;|$)/i);
  return mimeTypeMatch ? mimeTypeMatch[1].toLowerCase() : '';
};

export const isContentTypeSupportedByImagePreview = (file: APIAttachment) =>
  isSupportedMimeType(extractMimeType(file['content-type'] ?? ''));

export enum ImageContentType {
  IMAGE = 'image',
  SVG = 'svg',
}

export type PreviewContent = {
  content: string;
  contentType: ImageContentType;
};
